import React from 'react';
import styled from 'styled-components';
import Textbox from '@zocdoc-frontend-common/components-textbox';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
    MetricsClickable,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { blue100, slate30 } from '@zocdoc-mezzanine/foundations-colors';
import {
    labelSmall,
    paragraphSmall,
} from '@zocdoc-mezzanine/foundations-typography';
import { GaActionText, TRACKING_ELEMENTS } from '../constants';

export const EmailField = ({
    showFieldLabel,
    defaultEmailValue,
    isInMultiStepSignIn,
    autoFocusEmailField,
    emailValidationError,
    sendMetric,
    trackEmailFieldSelect,
    onChangeEmailInput,
    onEditEmailClick,
}) => {
    const handleEmailFocus = () => {
        trackEmailFieldSelect();
        sendMetric({
            action: GaActionText.trackEmailFieldSelect,
            element: TRACKING_ELEMENTS.emailTextbox,
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.SELECT,
        });
    };

    const handleEmailChange = (e) => onChangeEmailInput(e.target.value);

    if (isInMultiStepSignIn) {
        return (
            <>
                <EmailWithEditContainer data-test="sign-in-email-with-edit-button">
                    <EmailTextField className="email-text exclude-from-playback">
                        {defaultEmailValue}
                    </EmailTextField>
                    <MetricsClickable
                        action={'Click Edit Email In Email First Flow'}
                        element={TRACKING_ELEMENTS.emailTextbox}
                    >
                        <EditText
                            data-test="edit-email-text"
                            onClick={onEditEmailClick}
                        >
                            Edit
                        </EditText>
                    </MetricsClickable>
                </EmailWithEditContainer>
                <HiddenEmailField
                    type="email"
                    value={defaultEmailValue}
                    name="email"
                    autoComplete="email"
                />
            </>
        );
    }

    return (
        <InputContainer data-test="email-input-container">
            <InputLabel
                data-test="sign-in-email-label"
                showFieldLabel={showFieldLabel}
            >
                {'Email address'}
            </InputLabel>
            <StyledTextbox
                className="email-input exclude-from-playback"
                data-test="email-input"
                data-uem-id="email-input"
                focusOnMount={autoFocusEmailField}
                invalidMessage={emailValidationError}
                onChange={handleEmailChange}
                onFocus={handleEmailFocus}
                placeholder="Email address"
                type="email"
                defaultValue={defaultEmailValue || ''}
                autoComplete="username"
            />
        </InputContainer>
    );
};

const InputLabel = styled.div`
    ${labelSmall};
    color: ${blue100};
    margin-bottom: 4px;
    text-align: left;

    display: ${(p) => (p.showFieldLabel ? 'block' : 'none')};
`;

const InputContainer = styled.label`
    display: block;
    margin-bottom: 8px;

    ${breakpoint.small} {
        margin-bottom: 12px;
    }
`;

const StyledTextbox = styled(Textbox)`
    &:focus::placeholder {
        color: ${slate30};
    }
`;

const EmailWithEditContainer = styled.div`
    display: flex;
    margin-bottom: 26px;
`;

const EmailTextField = styled.p`
    ${paragraphSmall};
    max-width: 90%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const EditText = styled.span`
    ${labelSmall};
    text-decoration: underline;
    cursor: pointer;
    margin-left: 12px;
    margin-top: 1px;
    display: block;
`;

const HiddenEmailField = styled.input`
    display: none;
`;
